import React, { Component } from 'react';
import {
  Card,
  Button,
  Table,
  Modal,
  message,
  Select,
  Space,
  Input,
} from 'antd';
import { reqRoles, reqAddRole, reqRolesDetail, reqDeleteRole } from '../../api';
import { PAGE_SIZE } from '../../utils/constants';
import ShowAuth from './components/auth';
import AddForm from './components/add';
import './role.css';

const { Option } = Select;

export default class Role extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roles: [],
      role: {},
      isShowAdd: false,
      isShowAuth: false,
      total: '',
      roleType: 0,
      currentPage: 1,
    };
    this.columns = [
      {
        title: '序号',
        dataIndex: 'index',
        // 序号根据当前页和每页数量计算
        render: (text, record, index) => {
          const number =
            ((this.state.currentPage || 1) - 1) * PAGE_SIZE + (index + 1);
          return number;
        },
        align: 'center',
      },
      {
        title: '角色名称',
        dataIndex: 'role_id',
        align: 'center',
      },
      {
        title: '描述',
        dataIndex: 'desc',
        align: 'center',
      },
    ];
  }

  // 获取角色列表
  getRoles = async (pagination = 1, value) => {
    const data = {
      role_id: value,
      verbose: '100',
      type: this.state.roleType,
      pageNumber: pagination,
      pageSize: PAGE_SIZE,
      desc: 'true',
      orderby: '_id desc',
    };
    const res = await reqRoles(data);
    if (res.status === 200) {
      const { result, total } = res;
      this.setState({
        roles: result,
        total,
        role: {},
        currentPage: pagination,
      });
    }
  };

  // 添加角色
  addRole = () => {
    this.setState({
      isShowAdd: false,
    });
    this.form.validateFields(async (error, values) => {
      this.form.resetFields();
      const result = await reqAddRole(values);
      if (result.status === 200) {
        message.success('添加角色成功');
        this.getRoles();
      } else {
        message.error(result.error);
      }
    });
  };

  // 删除角色
  deleteRole = role => {
    const { role_id } = role;
    Modal.confirm({
      content: `确定删除${role_id}吗？`,
      onOk: async () => {
        const result = await reqDeleteRole(encodeURI(role_id));
        if (result.status === 204) {
          message.success('删除成功');
          this.setState({
            role: {},
          });
          this.getRoles();
        } else {
          message.error(result.error);
        }
      },
    });
  };

  // 查看角色详情
  detailRole = async role => {
    this.setState({
      isShowAdd: true,
      titleFlag: '更新角色',
    });
    const { role_id } = role;
    const { result } = await reqRolesDetail(encodeURI(role_id));
    this.setState({
      role: result,
    });
  };

  // 切换角色类型
  handleChange = value => {
    this.setState(
      {
        roleType: value,
      },
      () => {
        this.getRoles();
      }
    );
  };

  // 取消添加角色
  cancelAdd = () => {
    this.form1.resetFields();
    this.setState({
      isShowAuth: false,
    });
  };

  // 处理分页
  handlePagination = pagination => {
    this.setState({
      currentPage: pagination,
    });
    this.getRoles(pagination);
  };

  componentDidMount() {
    this.getRoles();
  }

  render() {
    const { roles, role, isShowAdd, isShowAuth, total, currentPage } =
      this.state;

    const title = (
      <Space>
        {/* 创建角色按钮 */}
        <Button
          type='primary'
          onClick={() => this.setState({ isShowAdd: true, role: {} })}
        >
          创建角色
        </Button>
        {/* 设置角色权限按钮 */}
        <Button
          type='primary'
          disabled={!role.id}
          onClick={() => {
            this.setState({ isShowAuth: true });
          }}
        >
          设置角色权限
        </Button>
        {/* 角色类型选择器 */}
        <Select
          defaultValue={0}
          onChange={this.handleChange}
        >
          <Option value={0}>系统角色</Option>
          <Option value={1}>用户角色</Option>
        </Select>
      </Space>
    );

    const extra = (
      // 查询角色输入框
      <Input.Search
        placeholder='查询角色'
        onSearch={value => this.getRoles(1, value)}
        enterButton
      />
    );

    return (
      <Card
        title={title}
        extra={extra}
      >
        {/* 角色列表 */}
        <Table
          bordered
          rowKey='id'
          dataSource={roles}
          columns={this.columns}
          pagination={{
            showSizeChanger: false,
            defaultPageSize: 10,
            total,
            showTotal: total => {
              return `共 ${total} 条`;
            },
            onChange: this.handlePagination,
            current: currentPage,
          }}
          rowSelection={{
            type: 'radio',
            selectedRowKeys: [role.id],
            onSelect: role => {
              console.log(role);
              this.setState({
                role,
              });
            },
          }}
        />
        {/* 添加角色弹窗 */}
        <Modal
          title={'创建角色'}
          onOk={this.addRole}
          open={isShowAdd}
          onCancel={() => {
            this.setState({
              isShowAdd: false,
            });
            this.form.resetFields();
          }}
        >
          <AddForm
            setForm={form => {
              this.form = form;
            }}
          />
        </Modal>
        {/* 设置角色权限弹窗 */}
        <Modal
          title='设置角色权限'
          open={isShowAuth}
          footer={null}
          onCancel={() => {
            this.setState({
              isShowAuth: false,
            });
          }}
        >
          <ShowAuth
            currentPage={currentPage}
            setForm={form => {
              this.form1 = form;
            }}
            role={role}
            roleType={this.state.roleType}
            cancelAdd={this.cancelAdd}
            getRoles={this.getRoles}
          />
        </Modal>
      </Card>
    );
  }
}
